import React from 'react'
import { Badge, Button, Popover } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import './notifications.scss'
import NotificationsList from './NotificationsList'
import NotificationsPopoverTitle from './NotificationsPopoverTitle'
import {
    useFetchNotificationsQuery,
    useMarkNotificationsAsReadMutation,
} from '../../../store/apis/notification.api'

const NotificationsButton = () => {
    const { data } = useFetchNotificationsQuery()
    const [markNotificationsAsRead] = useMarkNotificationsAsReadMutation()

    const handleOpenChange = opened => {
        const unseenNotificationsIds = data.notifications?.reduce((acc, notification) => {
            if (!notification.read) acc.push(notification.id)
            return acc
        }, [])
        if (!opened && unseenNotificationsIds.length) markNotificationsAsRead({ ids: unseenNotificationsIds })
    }

    const popoverTitle = (
        <NotificationsPopoverTitle
            hasUnreadNotifications={data?.totalUnread > 0}
        />
    )

    return (
        <Popover
            key='notifications'
            title={popoverTitle}
            content={<NotificationsList />}
            trigger={['click']}
            placement='bottomRight'
            getPopupContainer={() => document.getElementById('site-layout-header')}
            onOpenChange={handleOpenChange}
        >
            <Badge className='badge-count-number' count={Math.max(data?.totalUnread ?? 0, 0)}>
                <Button type='text' shape='circle' size='large' icon={<BellOutlined />} aria-label='notifications' />
            </Badge>
        </Popover>
    )
}

export default NotificationsButton
